module.exports = __webpack_public_path__ + "static/img/tup1.6b2e0bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tup1.png
// module id = Qm4m
// module chunks = 3